export default {
  methods: {
    $isNew(project){
      return project.latest_version === null
    }
  }
}